module.exports = __webpack_public_path__ + "img/su-flow.74f1dfd8.png";